<script lang="ts">
  import { melt } from "@melt-ui/svelte";
  import { getAccordionContext } from "./context.js";
  import { generateId } from "@poolsideai/lib/string";
  import { slide } from "svelte/transition";
  import { ChevronUp } from "../../icons/index.js";
  import type { Snippet } from "svelte";
  import type { ClassValue } from "svelte/elements";

  interface Props {
    title?: Snippet;
    children?: Snippet;
    class?: ClassValue;
  }

  let { title, children, class: className }: Props = $props();

  const uid = generateId();

  const { item, content, trigger, isSelected } = getAccordionContext();

	let __MELTUI_BUILDER_0__ = $derived($item(uid));
	let __MELTUI_BUILDER_1__ = $derived($trigger(uid));
	let __MELTUI_BUILDER_2__ = $derived($content(uid));
</script>

<div
  {...__MELTUI_BUILDER_0__} use:__MELTUI_BUILDER_0__.action
  class={[
    $isSelected(uid) ? "bg-mono-200" : "bg-mono-100",
    "transition-colors duration-150 last:rounded-b-[15px] hover:bg-mono-200",
    className,
  ]}
>
  <h3>
    <button
      type="button"
      {...__MELTUI_BUILDER_1__} use:__MELTUI_BUILDER_1__.action
      class="flex min-h-10 w-full items-center justify-between px-4 py-1 text-sm"
    >
      {@render title?.()}

      <ChevronUp
        class={[
          $isSelected(uid) ? "rotate-180" : "rotate-90",
          "text-subtle transition-transform duration-150",
        ]}
      />
    </button>
  </h3>

  {#if $isSelected(uid)}
    <div
      {...__MELTUI_BUILDER_2__} use:__MELTUI_BUILDER_2__.action
      transition:slide={{ duration: 150 }}
      class="overflow-auto border-t border-t-border p-4 pt-3 text-sm leading-5 text-foreground-secondary"
    >
      {@render children?.()}
    </div>
  {/if}
</div>
